if (!customElements.get('kb-component-image')) {
  customElements.define('kb-component-image', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('[data-open]');
      const closer = this.querySelector('[data-close]');
      if (!dialog || !opener || !closer) return;
      opener.addEventListener('click', () => {
        if (!dialog.open) dialog.showModal();
      });
      closer.addEventListener('click', () => dialog.close());
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const focusable = [...dialog.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')]
          .filter(element => !element.disabled && element.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
      dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (opener.isConnected) opener.focus();
      });
    }
  });
}
